/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ShareBeforeDiscounts/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function ShareBeforeDiscounts({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Summary/Payors/Payor/ShareBeforeDiscounts"
  
}) {
let payorShareAmountValueData = fromData.useDataFormat({ viewPath,
context: 'payor',
path: 'share.amount',
format: fromFormat.numberMoney,
})
let dtColorsBlack = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.black'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="payor.share.amount"
 format="/Data/format.js numberMoney"
 text={payorShareAmountValueData}
 weight="medium"
 color={dtColorsBlack}
 marginLeft={dtSpaceS}
/>
{children}
</React.Fragment>)
}